<template>
  <div style="height:320px;background-color: rgba(59, 67, 242, 100);font-size: 16px;">
    <div style="padding-bottom: 6%"></div>
    <a-row :gutter="[0, 40]">
      <a-col :md="4"></a-col>
      <a-col :md="6">
        <h3 style="color: white">产品</h3>
        <p><router-link style="color:white;opacity: 0.65;font-size: 12px;font-weight: normal;" to='/productintr'>产品介绍</router-link></p>
        <p><router-link style="color:white;opacity: 0.65;font-size: 12px;font-weight: normal;" to='/caseinfo'>业绩案例</router-link></p>
      </a-col>
      <a-col :md="6">
        <h3 style="color: white">企业介绍</h3>
        <p><router-link style="color:white;opacity: 0.65;font-size: 12px;font-weight: normal;" to='/aboutus'>关于我们</router-link></p>
        <p><router-link style="color:white;opacity: 0.65;font-size: 12px;font-weight: normal;" to='/contantus'>联系我们</router-link></p>
      </a-col>
      <a-col :md="8">
        <h3 style="color: white">南京汇钧云合科技有限公司</h3>
        <p style="opacity: 0.75;font-size: 12px;color: white">地址：江苏省南京市建邺区奥体大街69号3栋106号</p>
        <p style="opacity: 0.75;font-size: 12px;color: white">电话：025-8663 0767</p>
        <p style="opacity: 0.75;font-size: 12px;color: white">邮箱：public@jsnanrui.com</p>
      </a-col>
    </a-row>
    <div style="text-align: center;opacity: 0.5;color: rgba(255, 255, 255, 100);font-size: 12px">
      <div>@2009-2021 南京汇钧云合科技有限公司 版权所有。</div>
      <div>
        <a href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备2026022695号-1</a>
<!--        <a href="https://beian.mps.gov.cn/#/query/webSearch">苏公网安备32010502010841号</a>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Website',
  data () {
    return {
      scaleW: 1,
      scaleH: 1,
      size:50,
      tabBarGutter:100
    }
  },
  created(){

  },
  methods: {
    callback(key) {
      console.log(key);
    },
  }
}
</script>
<style>
  .anchorBL {
    display: none;
  }
  .BMap_cpyCtrl .BMap_noprint .anchorBL {
    display: none;
  }
</style>
<style scoped>
  a{
    color: #FFFFFF;
    margin-right: 5px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/footboot1.vue